type TtimeUnit = 'month' | 'week' | 'day'

export function getCustomTimeUnitByDays(days: number): TtimeUnit {
  if (days > 90) {
    return 'month'
  }

  if (days > 30) {
    return 'week'
  }

  return 'day'
}
